module.exports = __webpack_public_path__ + "img/thank-you.82ae7244.svg";